import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=5db088bc&"
import script from "./SidebarComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports